// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
  getDocFromServer
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAkDIyxqrLXw5t8QBASmtfwtmMADYgpIC4",
  authDomain: "scc-group-87997.firebaseapp.com",
  projectId: "scc-group-87997",
  storageBucket: "scc-group-87997.appspot.com",
  messagingSenderId: "994017216000",
  appId: "1:994017216000:web:e14b2a53bf13bfebb6fae5",
  measurementId: "G-Y31MV2K3G0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// Auth

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users", where("uid", "==", user.uid)));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email
      });
    }
  } catch (e) {
    console.error(e);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (error) {
    console.error(error);
    alert(error.message);
  }
};

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset email sent.");
  } catch (error) {
    console.error(error);
    alert(error.message);
  }
};

const logout = () => {
  try {
    signOut(auth);
  } catch (error) {
    console.error(error.message);
    alert(error.message);
  }
};

// firebase

const addApplicant = async (node) => {
  try {
    const docRef = await addDoc(collection(db, "applicants"), node);
    console.log("Applicant added with id: ", docRef.id);
  } catch (error) {
    console.error(error.message);
    alert(error.message);
  }
};

export {
  addApplicant,
  auth,
  db,
  signInWithGoogle,
  sendPasswordReset,
  logInWithEmailAndPassword,
  logout
};
